// @flow

export default {
  type: "array",
  title: "Form Questions",
  minItems: 1,
  items: {
    type: "object",
    required: ["questionText", "isActive", "type"],
    dependencies: {
      type: {
        oneOf: [
          {
            properties: {
              type: { const: "QUESTION" },
            },
          },
          {
            properties: {
              type: { const: "STATEMENT" },
            },
          },
        ],
      },
    },
    properties: {
      questionText: {
        type: "string",
        title: "Question Text",
        maxLength: 500,
        minLength: 1,
      },
      questionType: {
        type: "string",
        title: "Question Type",
        oneOf: [
          {
            title: "Confirmation",
            const: "CONFIRMATION",
          },
          {
            title: "Date pick",
            const: "DATE_PICK",
          },
          {
            title: "Free text",
            const: "FREE_TEXT",
          },
          {
            title: "Multi select",
            const: "MULTI_SELECT",
          },
          {
            title: "Single select",
            const: "SINGLE_SELECT",
          },
        ],
      },
      isMandatory: {
        type: "boolean",
        title: "Is Mandatory",
      },
      id: {
        type: ["integer", "null"], // for new questions id is not yet created by BE so it's null at that point
        title: "Form Question",
      },
      type: {
        type: "string",
        title: "Type",
        oneOf: [
          {
            title: "Question",
            const: "QUESTION",
          },
          {
            title: "Statement",
            const: "STATEMENT",
          },
        ],
      },
      isActive: {
        type: "boolean",
        title: "Is Active",
      },
    },
  },
};
